<template>
    <div class="select-team-list">
      <div class="title">球队列表</div>
      <van-loading v-if="loading" class="loading" type="spinner" vertical>加载中...</van-loading>
      <van-empty v-else-if="!loading && list.length === 0" description="暂无管理的球队" />
      <div v-else class="team-list">
        <div class="team-item" v-for="item in list" :key="item.id" @click="selectTeam(item)">
          <div class="logo">
            <img v-if="item.badge" :src="imageView(item.badge)" alt="logo">
            <img v-else src="@/assets/default-icon.png" alt="logo">
          </div>
          <div class="team-info">
            <div class="team-name">{{ item.teamName }}</div>
            <div class="category-name">{{ item.categoryName || '-' }}</div>
            <div class="quantity">球员人数：{{ item.playerCount || 0}}人</div>
          </div>
          <div class="checkbox">
            <van-checkbox :value="item.id === orgTeamId" />
          </div>
        </div>
      </div>
      <div class="add-team" @click="goRegisterTeam">+ 注册新球队</div>


       <div class="bottom">
        <div class="confirm" :class="{ disabled: !orgTeamId }" @click="onConfirm">确认</div>
       </div>
    </div>
</template>

<script>
import { Checkbox, Loading, Empty, Dialog } from 'vant';
import Vue from 'vue';
import { getOrgTeamsManaged, checkTeamSignupBMMatch } from '@/api/match';
import { QNImageUtil } from '@/utils';
import wx from 'weixin-js-sdk';
Vue.use(Checkbox);
Vue.use(Loading);
Vue.use(Empty);
Vue.use(Dialog);

export default {
    data() {
        return {
            orgTeamId: '',
            list: [],
            loading: false
        };
    },
    computed: {
        imageView() {
            return (hash) => (hash ? QNImageUtil.imageView(hash) : '');
        }
    },
    mounted() {
        this.orgTeamId = this.$route.query.orgTeamId || '';
        this.fetchList();
    },
    methods: {
        async fetchList() {
            this.loading = true;
            try {
                const res = await getOrgTeamsManaged({accountId: this.$route.query.accountId});
                const raw = res && (res.data ?? res.list ?? res);
                const arr = Array.isArray(raw) ? raw : (raw && raw.list) ? raw.list : [];
                this.list = arr.map((item) => ({
                    id: item.id ?? item.teamId ?? item.regTeamId,
                    badge: item.badge ?? item.logo,
                    teamName: item.teamName ?? item.name,
                    categoryName: item.categoryName ?? (item.category && item.category.name),
                    playerCount: item.playerCount ?? item.memberCount ?? 0,
                    currentStep: item.currentStep,
                    currentStatus: item.currentStatus,
                    termId: item.termId,
                    regTeamId: item.regTeamId,
                    orderId: item.orderId,
                }));
            } catch (e) {
                this.$toast.fail(e?.message || '获取球队列表失败');
                this.list = [];
            } finally {
                this.loading = false;
            }
        },
        async selectTeam(item) {
            const orgTeamId = item.id;
            const { matchId } = this.$route.query;
            try {
                const res = await checkTeamSignupBMMatch({
                    matchId,
                    teamId: orgTeamId
                });
                const data = res && (res.data || res) || {};
                const isInCategories = !!data.isInCategories; // 是否符合类别
                const registerComplete =
                    data.registerComplete !== undefined && data.registerComplete !== null
                        ? Number(data.registerComplete)
                        : (data.isRegisterComplete ? 1 : 0);
                const isRegisterComplete = registerComplete === 1; // 是否已完成注册
                const isSignup = !!data.isSignup; // 是否已报名
              const currentStep = item.currentStep;
                console.log(currentStep,'currentStep');
                
                // const currentStatus = data.currentStatus;

                // 3. 已报名 → 无需重复提交
                if (isSignup) {
                    Dialog.alert({
                        title: '提示',
                        message: '你已成功报名，无需重复提交',
                        confirmButtonText: '关闭'
                    });
                    return;
                }

                // 2. 未完成球队注册：分「未提交资料」与「已提交资料未支付」
                if (!isRegisterComplete) {
                    // 2.1 已提交资料但未完成支付（Team.Review 已提交资料 / Team.Fee 已创建订单）
                  const step = (currentStep || '').toString()
                     console.log(step,'step');
                     
                    if (step === 'Team.Review' || step === 'Team.Fee') {
                        Dialog.confirm({
                            title: '提示',
                            message: '报名前，请先支付注册费用',
                            cancelButtonText: '取消',
                            confirmButtonText: '去支付'
                        }).then(() => {
                          // 根据产品需求补充去支付跳转逻辑
                          if (item.orderId) {
                            wx.miniProgram.navigateTo({
                              url: `/pages/order/detail/index?id=${item.orderId}`
                            })
                          } else {
                            wx.miniProgram.navigateTo({
                              url: `/pages/season_registration/order_confirm/index?id=${item.termId}&regTeamId=${item.regTeamId}`
                            })
                          }
                        }).catch(() => {});
                        return;
                    }

                    // 2.2 未提交资料（未注册）：Team.Form 或其它未提交状态，提示前往注册
                    Dialog.confirm({
                        title: '提示',
                        message: '报名前，请先完成球队注册',
                        cancelButtonText: '取消',
                        confirmButtonText: '去注册'
                    }).then(() => {
                      // 根据产品需求补充去注册跳转逻辑
                        wx.miniProgram.navigateTo({
                          url: '/pages/season_registration/registered_particulars/index'
                        })
                    }).catch(() => {});
                    return;
                }

                // 4. 组别不符合要求
                if (!isInCategories) {
                    Dialog.alert({
                        title: '提示',
                        message: '报名组别不符合要求，请重新选择',
                        confirmButtonText: '关闭'
                    });
                    return;
                }

                // 1. 满足报名，直接选中
                this.orgTeamId = this.orgTeamId === orgTeamId ? '' : orgTeamId;
            } catch (e) {
                this.$toast.fail(e?.message || '检查报名条件失败');
            }
        },
        onConfirm() {
            if (!this.orgTeamId) {
                this.$toast('请先选择球队');
                return;
            }
            const { unionMatchId, matchId } = this.$route.query;
            this.$router.replace({
                path: '/entry-page/entry-info-team',
                query: {
                    unionMatchId: unionMatchId || '',
                    matchId: matchId || '',
                    orgTeamId: this.orgTeamId
                }
            });
      },
      goRegisterTeam() { 
        wx.miniProgram.navigateTo({
          url: '/pages/season_registration/registered_particulars/index'
        })
      }
    },
};
</script>

<style scoped lang="scss">
.select-team-list{
  min-height: 100vh;
  background-color: var(--bg2,#EEEEF1);
  padding: 16px;
  box-sizing: border-box;
  padding-bottom: 120px;
  .loading{
    padding: 40px 0;
    text-align: center;
  }
  .title{
    color: #303133;
    font-size: 15px;
  }
  .team-list{
    .team-item{
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      padding: 15px;
      background-color: var(--bg1,#FFFFFF);
      border-radius: 3px;
      .logo{
        width: 40px;
        height: 40px;
        border-radius: 5px;
        background: #D8D8D8;
        img{
          width: 100%;
          height: 100%;
          border-radius: 5px;
        }
      }
      .team-info{
        flex: 1;
        margin-left: 10px;
        .team-name{
          font-size: 16px;
          font-weight: 500;
          color: var(--font-color1, #333);
        }
        .category-name{
          font-size: 12px;
          color: var(--font-color2, #666);
          margin-top: 5px;
        }
        .quantity{
          font-size: 12px;
          color: var(--font-color2, #666);
        }
      }
      .checkbox{
        // 垂直居中
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
.add-team{
  width: 343px;
  height: 51px;
  border-radius: 5px;
  background-color: #C6E2FF;
  text-align: center;
  line-height: 51px;
  font-size: 16px;
  font-weight: 500;
  color: #337ECC;
  margin: 10px auto;
}
.bottom{
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100vw;
    padding: 16px;
    padding-bottom: 44px;
    box-sizing: border-box;
    background-color: var(--bg1,#fff);
  .confirm{
    height: 45px;
    border-radius: 5px;
    text-align: center;
    color: #fff;
    background-color: #1D2088;
    line-height: 45px;
    &.disabled {
      opacity: 0.6;
    }
  }
}
</style>
